import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import md5 from 'js-md5'
import urls from '../common/js/urls.js'

export function api_my_course(category, user_id, pageNum) {
  var promise = new Promise(function (resolve, reject) {
    axios.get(urls.my_course + '?userid=' + user_id + '&category=' + category + '&pageNum=' + pageNum + '&pageSize=20&application_id=1').then((response) => {
      resolve(response.data.result);
    }).catch((response) => {
      reject(response);
    });
  });
  return promise;
};





// WEBPACK FOOTER //
// ./src/networks/UserHandler.js